class VocLogger {
  constructor(app) {
    this.app = app;
    this.libPath = app.lookup('vocento.config.nibara').libPath;
    if (this.libPath === undefined) {
      throw 'nibara libPath config is empty';
    }
  }

  initialize() {
    return this.app.load(this.libPath + 'js-logger/logger.min.js').then(() => {

      /** logger init **/
      Logger.useDefaults();
      let myHandler = Logger.createDefaultHandler({
        formatter: (messages) => {
          messages.unshift('nibara_debug::');
        }
      });
      Logger.setHandler((messages, context) => {
        myHandler(messages, context);
      });

      /** Change level with require_debug param */
      Logger.setLevel(Logger.WARN);
      if (VocLogger.getUrlParam('nibara_debug') === '1') {
        Logger.setLevel(Logger.DEBUG);
      }
    });
  }

  /**
   * Obtiene el valor de un parametro de la window.location
   */
  static getUrlParam(name) {
    let hashes = window.location.search.slice(1).split('&');
    let hash;
    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      if (hash[0] === name) {
        return hash.length > 1 ? hash[1] : '';
      }
    }
    return null;
  }
}
export default VocLogger;



// WEBPACK FOOTER //
// ./src/VocLogger.js